// source: design/src/pages/ERPPage.tsx (export 2026-04-24)
/* eslint-disable max-len */
import SI from '../si/si_ja';

export default {
  // Reuse shared SI common copy to keep sub-pages aligned with SI root updates.
  common: SI.common,
  heroImage: 'si/images/hero-erp.jpg',
  heroTitle: '企業資源計画（ERP）',
  heroTagline: '企業の核心リソースを統合し、効率的な運営管理を実現',
  intro: [
    'ERP（Enterprise Resource Planning）は、現代企業管理の核心情報システムであり、財務、購買、生産、販売、人事、サプライチェーンなどの主要業務プロセスを統合し、データの一元管理とリアルタイム共有を実現します。',
    '企業のデジタルトランスフォーメーションの基盤として、ERPシステムは部門間の情報サイロを打破し、標準化された業務プロセスを構築し、経営層に正確でタイムリーな意思決定支援データを提供します。',
    '飛狼は豊富なERP導入実績を持ち、製造、小売、建設、医療などの複数業界に深くサービスを提供し、企業にニーズ分析、システム選定、カスタム開発から運用保守までの全工程サービスを提供します。',
  ],
  modules: [
    {
      icon: 'si/si-icons/dollar-sign.svg',
      title: '財務管理',
      desc: '総勘定元帳、売掛金・買掛金、固定資産、原価計算などの核心財務機能をカバー。複数通貨、複数会計基準に対応し、財務業務の一体化を実現します。',
    },
    {
      icon: 'si/si-icons/shopping-bag.svg',
      title: 'サプライチェーン管理',
      desc: '購買、在庫、販売・流通の全工程を統合し、購買依頼、サプライヤー管理、見積比較から注文追跡、入庫検収、出庫出荷までのエンドツーエンド管理を実現し、サプライチェーンの協業とコスト管理を最適化します。',
    },
    {
      icon: 'si/si-icons/calendar.svg',
      title: '生産計画',
      desc: 'MRP演算に基づく生産計画スケジューリング。受注生産（MTO）、見込生産（MTS）などの複数モードをサポートし、設備稼働率を向上させます。',
    },
    {
      icon: 'si/si-icons/users.svg',
      title: '人事管理',
      desc: '組織構造、従業員情報、勤怠給与、パフォーマンス評価、採用研修などの人事全工程を管理します。',
    },
    {
      icon: 'si/si-icons/clipboard-list.svg',
      title: 'プロジェクト管理',
      desc: 'プロジェクト立案、タスク分解、進度追跡、コスト管理、資源配分、プロジェクト決算の一体化管理を実現します。',
    },
    {
      icon: 'si/si-icons/bar-chart-3.svg',
      title: 'レポートと分析',
      desc: '多次元の業務レポートとBI分析ツールを内蔵。カスタムレポートとリアルタイムデータダッシュボード表示をサポートします。',
    },
  ],
  scenarios: [
    {
      icon: 'si/si-icons/factory.svg',
      title: '製造業',
      desc: 'ERPシステムは製造企業の原材料購買から生産スケジューリング、品質検査、製品入庫までの全工程のデジタル管理を支援し、生産サイクルを15%〜25%短縮します。',
    },
    {
      icon: 'si/si-icons/store.svg',
      title: '小売業',
      desc: 'マルチチャネル在庫の一元管理、会員データ分析、サプライチェーンの連携をサポートし、小売企業の在庫回転率を20%以上向上させます。',
    },
    {
      icon: 'si/si-icons/building-2.svg',
      title: '建築・建設',
      desc: 'プロジェクトコストの精細管理、資材購買の最適化、工事進度の追跡を実現し、プロジェクトの超過リスクを効果的に抑制します。',
    },
    {
      icon: 'si/si-icons/heart-pulse.svg',
      title: '医療・ヘルスケア',
      desc: '医療機器のトレーサビリティ、薬品ロット管理、コンプライアンス監査などの厳格な要求を満たし、GMP/GSP規格に対応します。',
    },
  ],
  benefits: [
    {
      number: '10-20%',
      title: '運営コスト削減',
      desc: 'プロセス最適化とリソース統合により、企業の運営コストを10%〜20%削減',
    },
    {
      number: '30%+',
      title: 'リアルタイムデータ駆動の意思決定',
      desc: '経営層はリアルタイムの業務データに基づいて正確な意思決定ができ、意思決定効率が30%以上向上',
    },
    {
      number: '60-80%',
      title: '部門間プロセス連携',
      desc: '情報サイロを打破し、業務プロセスの自動化率が60%〜80%に達する',
    },
    {
      number: '100%',
      title: 'コンプライアンスと監査の保証',
      desc: '監査追跡と権限管理を内蔵し、等級保護および業界コンプライアンス要件を満たす',
    },
  ],
};
